/* 書類提出（お申込人） */
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Shelf from '../../molecules/Shelf';
import FileUploadTemplate from '../../organisms/FileUpload';
import { FileUpload } from '../../types/FileUpload';

// TODO sakuma モック用の値。項目が決まり次第修正
import {
  person_initialState,
  certification_initialState,
  document_initialState,
} from '../../Const';

const DocumentInput: React.FC = () => {
  const [person_files_upload, setPersonFilesUpload] = useState<FileUpload[]>(person_initialState);
  const [certification_files_upload, setCertificationFilesUpload] = useState<FileUpload[]>(
    certification_initialState
  );
  const [document_files_upload, setDocumentFilesUpload] = useState<FileUpload[]>(
    document_initialState
  );
  // TODO sakuma 適切な場所に移動する
  const [open, setOpen] = useState(true);
  return (
    <Shelf label="添付書類" is_open={true} handleClick={() => setOpen(!open)}>
      <>
        <FileUploadTemplate
          files_upload={person_files_upload}
          setFilesUpload={setPersonFilesUpload}
          files_upload_info={{
            reception: {
              ident_lv1_cd: '',
              ident_lv2_cd: '',
              ident_lv3_cd: '',
              reception_id: 0,
              reception_cd: '',
              reception_sub_cd: '',
            },
            attention: '',
          }}
          handleNextButtonClick={() => function() {}}
          next_button_disabled={false}
        />
        <FileUploadTemplate
          files_upload={certification_files_upload}
          setFilesUpload={setCertificationFilesUpload}
          files_upload_info={{
            reception: {
              ident_lv1_cd: '',
              ident_lv2_cd: '',
              ident_lv3_cd: '',
              reception_id: 0,
              reception_cd: '',
              reception_sub_cd: '',
            },
            attention: '',
          }}
          handleNextButtonClick={() => function() {}}
          next_button_disabled={false}
        />
        <FileUploadTemplate
          files_upload={document_files_upload}
          setFilesUpload={setDocumentFilesUpload}
          files_upload_info={{
            reception: {
              ident_lv1_cd: '',
              ident_lv2_cd: '',
              ident_lv3_cd: '',
              reception_id: 0,
              reception_cd: '',
              reception_sub_cd: '',
            },
            attention: '',
          }}
          handleNextButtonClick={() => function() {}}
          next_button_disabled={false}
        />
      </>
    </Shelf>
  );
};

if (document.getElementById('applicant_document_input')) {
  ReactDOM.render(<DocumentInput />, document.getElementById('applicant_document_input'));
}
